import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import SidebarClubManagerContent from "./sidebarClubManagerContent";

const SidebarClubManager = () => (
  <div className="vertical-menu">
    <div data-simplebar className="h-100">
      <SidebarClubManagerContent />
    </div>
    <div className="sidebar-background" />
  </div>
);

const mapStateToProps = (state) => ({
  layout: state.Layout,
});

export default connect(mapStateToProps, {})(withTranslation()(SidebarClubManager));
